import type { TimeSlot } from '@cencosud-cencommerce/paris-uikit/dist/molecules/Cards/CardDeliveryInfo/interfaces';

import { TimeSlotNames } from '@/Pages/BuyNowPage/PaymentAndShipping/interfaces';

export const LABEL_WHEN_DO_YOU_WANT_TO_RECEIVE =
  '¿Cuándo quieres recibir tu compra?';
export const LABEL_DELIVERY_SCHEDULE = 'Horario de entrega:';
export const LABEL_DELIVERY_COST = 'Costo de despacho:';
export const DELIVERY_TIME = '09:00 y 21:00 horas';
export const DELIVERY_COST = '$3.990';
export const LABEL_CONFIRM = 'Confirmar';
export const DEFAULT_TIME_SLOTS: TimeSlot[] = [
  {
    name: TimeSlotNames.AM1,
    deliveryTimeStart: '08:00',
    deliveryTimeEnd: '12:00'
  },
  {
    name: TimeSlotNames.PM1,
    deliveryTimeStart: '12:00',
    deliveryTimeEnd: '16:00'
  },
  {
    name: TimeSlotNames.PM2,
    deliveryTimeStart: '16:00',
    deliveryTimeEnd: '20:00'
  }
];
